export function buildIncyDeepLink(subscriptionUrl) {
    return `incy://add/${subscriptionUrl}`;
}

export function openInIncy(subscriptionUrl) {
    window.location.href = buildIncyDeepLink(subscriptionUrl);
}
